<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { worldStore, dispatch } from '@sim/store';
  import { BUILDABLE, roomDef, zoneOf, ZONE_META, ZONE_ALLOWED } from '@sim/config';
  import { activeBuilding } from '@sim/world';
  import { money } from '@sim/selectors';

  export let floor: number;
  export let slot: number;
  const emit = createEventDispatcher();

  $: city = $worldStore;
  $: b = activeBuilding(city)!;
  $: zone = zoneOf(floor, b.floorMax);
  $: zm = ZONE_META[zone];
  $: allowed = BUILDABLE.filter((t) => ZONE_ALLOWED[zone].includes(t));

  function build(type: (typeof BUILDABLE)[number]) {
    dispatch({ type: 'buildRoom', floor, slot, roomType: type });
    emit('close');
  }
</script>

<div class="sheet">
  <div class="head">
    <div class="ht">
      <span class="title">Build here</span>
      <span class="zone" style="color:{zm.accent}">{zm.label}</span>
    </div>
    <button class="x" on:click={() => emit('close')}>✕</button>
  </div>
  <div class="grid">
    {#each allowed as type}
      {@const def = roomDef(type)}
      {@const can = city.cash >= def.cost}
      <button class="card" style="--accent:{def.accent}" disabled={!can} on:click={() => build(type)}>
        <span class="ic">{def.icon}</span>
        <span class="nm">{def.name}</span>
        <span class="bl">{def.blurb}</span>
        <span class="cost mono" class:no={!can}>{money(def.cost)}</span>
      </button>
    {/each}
  </div>
</div>

<style>
  .sheet {
    background: var(--panel);
    border: 1px solid var(--line);
    border-radius: 14px;
    padding: 12px;
    box-shadow: var(--shadow);
  }
  .head {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .ht {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }
  .title {
    font-weight: 800;
    font-size: 15px;
  }
  .zone {
    font-size: 11px;
    font-weight: 700;
  }
  .x {
    margin-left: auto;
    font-size: 15px;
    color: var(--ink-dim);
    padding: 2px 6px;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding: 9px;
    border-radius: 10px;
    background: linear-gradient(180deg, color-mix(in srgb, var(--accent) 12%, var(--panel-2)), var(--panel-2));
    border: 1px solid color-mix(in srgb, var(--accent) 35%, var(--line));
    color: var(--ink);
    text-align: left;
  }
  .ic {
    font-size: 19px;
  }
  .nm {
    font-weight: 800;
    font-size: 12px;
    color: var(--accent);
  }
  .bl {
    font-size: 9.5px;
    color: var(--ink-dim);
    line-height: 1.25;
  }
  .cost {
    margin-top: 3px;
    font-size: 12px;
    font-weight: 700;
    color: var(--cash);
  }
  .cost.no {
    color: var(--bad);
  }
</style>
